import angular from 'angular';
import uiCianIcon from '../icon/index.jsm';
import template from './template.jade';
import './styles.styl';

export default angular
	.module('ui.cian.tag', [uiCianIcon])
	.directive('cianUiTag', () => ({
		restrict: 'AE',
		scope: true,
		bindToController: {
			// Клик по крестику
			onClose: '&?',
			hoverable: '@?',
		},
		controller: [function () {
			const ctrl = this;
			ctrl.isHoverable =
				angular.isDefined(ctrl.hoverable) &&
				ctrl.hoverable !== 'false';
		}],
		controllerAs: 'tag',
		transclude: true,
		replace: true,
		template
	}))
	.name;



// WEBPACK FOOTER //
// ./~/@cian/ui/app/components/tag/index.jsm